const initParamGroupData = {
  
}

export function paramGroupData(
  state = initParamGroupData,
  action
) {
  switch (action.type) {
    case "PARAM_GROUP_FETCH_DATA_SUCCESS":
      return action.dataParamGroup;
    default:
      return state;
  }
}